import moment from 'moment'
import { getOrderDailyInfo } from '@/utils/api'

const dayFormat = 'YYYY-MM-DD'
const today = moment().format(dayFormat) // 当天日期
const emptyData = {
  leafNodes: [],
  subList: [{
    type: 1,
    typeName: '梯内屏',
    leafNodes: [],
    subList: []
  }, {
    type: 2,
    typeName: '梯外屏',
    leafNodes: [],
    subList: []
  }]
}

export default {
  props: {
    orderInfo: {
      type: Object,
      default () { return {} }
    },
    accordion: { // 是否同时只能展开一个小区(手风琴模式)
      type: Boolean,
      default: false
    }
  },
  data () {
    let vm = this
    return {
      loading: false,
      zoneParam: [],
      chooseDate: moment().format(dayFormat), // 下载监播截图数据的日期(需在订单开始日期至今天的日期范围内)
      pickerOption: {
        disabledDate (date) {
          const cur = moment(date)
          if (cur.isAfter(today, 'day')) return true
          if (vm.orderStart && cur.isBefore(vm.orderStart, 'day')) return true
          return false
        }
      },
      searchTxt: '',
      monitTaskName: '',   // 监播任务名称
      mTypes: [], // 监播任务类型(屏幕、相机)
      downWay: 0, // 下载方式(汇总:0,分城市:1)
      tipNone: '暂无数据', // 当前时间超出投放时段或订单已完成无小区数据时的提示
      /** 组装后的最外层级数据对象
        {
          leafNodes: [],
          subList: [{
            type: 1,
            typeName: '梯内屏',
            leafNodes: [],
            subList: []
          }, {
            type: 2,
            typeName: '梯外屏',
            leafNodes: [],
            subList: []
          }]
        }
       */
      outlayerData: null,
    }
  },
  computed: {
    orderStart () {
      if (this.orderInfo && this.orderInfo.startDate) {
        return moment(this.orderInfo.startDate)
      }
      return null
    },
    playTimes () {
      if (this.orderInfo.timeSlotNames) {
        let slotNames = this.orderInfo.timeSlotNames //"06:00-09:00（播放50次） 09:00-12:00（播放50次） 12:00-15:00（播放50次）"
        let playTimes = slotNames.replace(/（[\u4e00-\u9fa5\w]+）/g, '').split(' ').join('；')
        return playTimes
      }
      return ''
    }
  },
  watch: {
    chooseDate () { // 更换日期重新请求小区数据
      this.getOrderNbhd()
    }
  },
  methods: {
    async getOrderNbhd () {  // 小区屏幕类型(0-全部，1-仅梯内，2-仅梯外)
      this.loading = true
      let res = await getOrderDailyInfo({
        districtRequests: this.zoneParam,
        guid: this.orderInfo.guid,
        targetDate: this.chooseDate,
        targetTime: moment().format('HH:mm'),
        screenType: this.screenType
      })
      this.loading = false
      if (res.code === 0) {
        let nbhdData = (res.data && res.data.nbhdDayilyListTn) || []
        let nbhdOutData = this.screenType === 1 ? [] : (res.data && res.data.nbhdDayilyListTw) || []
        let layerData = {
          subList: [
            {
              type: 1,
              typeName: '梯内屏',
              subList: nbhdData
            }, {
              type: 2,
              typeName: '梯外屏',
              subList: nbhdOutData
            }
          ]
        }
        this.handleData(layerData, this.checkAll, false)
        Object.preventExtensions(layerData)
        this.outlayerData = layerData
      } else {
        this.handleAbnormals(res.code, res.msg)
        this.outlayerData = emptyData
      }
    },
    async searchNbhdByArea (zoneReq) {
      this.zoneParam = zoneReq
      this.loading = true
      let res = await getOrderDailyInfo({
        districtRequests: this.zoneParam,
        guid: this.orderInfo.guid,
        targetDate: this.chooseDate,
        targetTime: moment().format('HH:mm'),
        screenType: this.screenType
      })
      this.loading = false
      if (res.code === 0) {
        let nbhdData = (res.data && res.data.nbhdDayilyListTn) || []
        let nbhdOutData = this.screenType === 1 ? [] : (res.data && res.data.nbhdDayilyListTw) || []
        let layerData = {
          subList: [
            {
              type: 1,
              typeName: '梯内屏',
              subList: nbhdData
            }, {
              type: 2,
              typeName: '梯外屏',
              subList: nbhdOutData
            }
          ]
        }
        this.handleData(layerData, this.checkAll, false)
        Object.preventExtensions(layerData)
        this.outlayerData = layerData
        layerData = null
      } else {
        this.outlayerData = emptyData
        this.handleAbnormals(res.code, res.msg)
      }
    },
    handleAbnormals (mistake, tipTxt) {
      if (mistake === 90007003) { // 当前时间超出投放时段范围时弹窗提示
        this.tipNone = tipTxt || `抱歉，您的订单投放时段为（${this.playTimes}），今天截图时段已过，请重新选择截图日期~`
      } else if (mistake === 90007004 || mistake === 90007008) { // 订单已完成
        this.tipNone = tipTxt || '订单投放结束，监播服务已关闭'
      } else if (mistake === 900501) { // 服务未开启
        this.tipNone = tipTxt || '监播服务服务暂未开启，敬请期待'
      } else {
        this.tipNone = '未查询到订单日小区数据'
      }
    },
    // ShotHeaderCp组件的提交监播截图任务事件(保存任务名&通知小区列表组件NbhdList将已勾选的小区及点位信息传递出来)
    noticeSubmit (name, mTypes, mode) {
      this.monitTaskName = name
      this.mTypes = mTypes
      this.downWay = mode
      if (this.$refs.listCp) {
        this.$refs.listCp.emitChooseInfo()
      }
    },
    /**
     * @description 递归方式小区数据处理函数
     * @param {Object} item 梯内梯外、小区、楼幢、单元等层次数据结构
     * @param {Boolean} check 是否勾选
     * @param {Boolean} uncertain 是否半选状态
     * @returns null
     */
    handleData (item, check, uncertain) {
      this.$set(item, 'checked', check) // checked及isIndeterminate涉及UI展现及用户操作，需用$set设置保证及时响应
      this.$set(item, 'isIndeterminate', uncertain)
      /**
       * Vue会递归遍历data对象的所有key，对所有数据项的每一个字段进行defineProperty操作
       * 当数据量很大时将是昂贵的耗时操作，提升性能就要减少无用字段(减少defineProperty次数)
       */
      if (item.slotAmount) delete item.slotAmount
      item.leafNodes = this.getAllLeafNode(item)
      // 移除$parent属性, 避免对象循环引用导致给Vue实例数据赋值时耗费性能
      // if (parent) item.$parent = parent
      let subL = item.subList || item.nbhdDeviceInfo || item.value
      if (subL && subL.length) {
        for (let i = 0; i < subL.length; i++) {
          this.handleData(subL[i], check, uncertain)
        }
      }
    },
    getAllLeafNode (item, leafKey = 'deviceGuid') { // 初始化递归所有数据时调用
      if (item.leafNodes && item.leafNodes.length) return item.leafNodes
      if (item[leafKey]) {
        item.leafNodes = [item]
        return item.leafNodes
      } else {
        return [].concat.apply([], this.getAllChild(item).map(el => this.getAllLeafNode(el)))
      }
    },
    getAllChild (item) { // 获取所有一级子级数据
      return item.subList || item.nbhdDeviceInfo || item.value || []
    },

    /**
     * @description 循环迭代方式小区数据处理函数
     * @param {Object} outest 梯内&梯外屏小区数据集合
     * @param {Boolean} check 是否勾选
     * @param {Boolean} uncertain 是否半选状态
     * @returns null
     */
    handleNbhd (outest, check, uncertain) {
      this.$set(outest, 'checked', check)
      this.$set(outest, 'isIndeterminate', uncertain)
      let typeArr = outest.subList
      if (typeArr) { // 第一层：梯内屏小区&梯外屏小区
        for (let n = 0, firl = typeArr.length; n < firl; n++) {
          let typeItem = typeArr[n]
          this.$set(typeItem, 'checked', check)
          this.$set(typeItem, 'isIndeterminate', uncertain)
          let nbhdArr = typeItem.subList || [] // 第二层：小区列表
          for (let m = 0, nl = nbhdArr.length; m < nl; m++) {
            let nbhd = nbhdArr[m]
            this.$set(nbhd, 'checked', check)
            this.$set(nbhd, 'isIndeterminate', uncertain)
            let buildArr = nbhd.nbhdDeviceInfo || [] // 第三层：楼幢列表
            for (let k = 0, bl = buildArr.length; k < bl; k++) {
              let build = buildArr[k]
              this.$set(build, 'checked', check)
              this.$set(build, 'isIndeterminate', uncertain)
              let unitArr = build.value || [] // 第四层：单元列表
              for (let j = 0, ul = unitArr.length; j < ul; j++) {
                let unit = unitArr[j]
                this.$set(unit, 'checked', check)
                this.$set(unit, 'isIndeterminate', uncertain)
                let liftArr = unit.value || [] // 第五层：电梯列表
                for (let i = 0, el = liftArr.length; i < el; i++) {
                  let lift = liftArr[i]
                  this.$set(lift, 'checked', check)
                  this.$set(lift, 'isIndeterminate', uncertain)
                  lift.leafNodes = [lift] // 电梯层的叶子节点等于电梯自身
                }
                unit.leafNodes = liftArr // 单元层级的叶子节点等于该单元下的所有电梯元素
              }
              build.leafNodes = this.addChildLeafNodes(unitArr)
            }
            nbhd.leafNodes = this.addChildLeafNodes(buildArr)
          }
          typeItem.leafNodes = this.addChildLeafNodes(nbhdArr)
        }
      }
      outest.leafNodes = this.addChildLeafNodes(typeArr)
    },
    addChildLeafNodes (arr) { // 累加所有一级子级元素的叶子节点
      return arr.reduce((pre, cur) => pre.concat(cur.leafNodes || []), [])
    }
  }
}
